import { useState } from 'react';
import { Link } from 'react-router-dom';
import myLogo from '../assets/images/second.jpeg';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <div>
      <header className="header">
        {/* Hamburger Icon (Left) */}
        <div className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar top"></div>
          <div className="bar middle"></div>
          <div className="bar bottom"></div>
        </div>

        {/* Logo (Right) */}
     <Link to="/">  <img src={myLogo} className="logo" alt="logo" width="50" height="50" /> </Link> 
        
        {/* Navigation */}
        <nav className={menuOpen ? 'mobile-nav active' : 'mobile-nav'}>
          <ul className="main-nav-links">
            <li><Link to="/" onClick={closeMenu}> Home </Link></li>
            <li><Link to="/pages/Service" onClick={closeMenu}> Service</Link></li>
            <li><Link to="/pages/PrivacyPolicy" onClick={closeMenu}> Privacy Policy</Link></li>
            <li><Link to="/pages/Team" onClick={closeMenu}> Team</Link></li>
            <li><Link to="/pages/Testimonials" onClick={closeMenu}> Testimonials </Link></li>
            <li><Link to="/pages/Faq" onClick={closeMenu}> FAQ</Link></li>
            <li><Link to="/pages/AboutUs" onClick={closeMenu}> About Us</Link></li>
          </ul>

          {/* Separate "Find a Designer" Section */}
          <div className="designer-section">
            <button className="findDesignerBtn" onClick={toggleDropdown}>
              <svg width="20" height="12" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"></path>
</svg>Find a Designer ▾
            </button>
            <ul className={`dropdown-designer ${dropdownOpen ? 'show' : ''}`}>
              <li><a href="mailto:konstructcyber@gmail.com" onClick={closeMenu}>Architectural Design</a></li>
              <li><a href="mailto:konstructcyber@gmail.com" onClick={closeMenu}>Structural Design</a></li>
              <li><a href="mailto:konstructcyber@gmail.com" onClick={closeMenu}>Mechanical Design</a></li>
              <li><a href="mailto:konstructcyber@gmail.com" onClick={closeMenu}>Electrical Design</a></li>
            </ul>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
